export function getQueryStringValue(key) {
    let location = ''

    try {
        location = (window && window.location && window.location.search) || ''
    } catch {}

    return decodeURIComponent(
        location.replace(
            new RegExp(
                '^(?:.*[&\\?]' + encodeURIComponent(key).replace(/[\.\+\*]/g, '\\$&') + '(?:\\=([^&]*))?)?.*$',
                'i'
            ),
            '$1'
        )
    )
}
